// removed by extract-text-webpack-plugin
module.exports = {"CardWrapper":"CardWrapper---1SvLQ","endUserAttributesCardPlaceholder":"endUserAttributesCardPlaceholder---3zkbO"};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/components/customer/EndUserAttributesCard/style.styl
// module id = UX+c
// module chunks = 89